<template>
  <v-chip
    class="attachment-button"
    :class="{
      'attachment-button--clickable': canDownload,
      'attachment-button--deactivated': !canDownload
    }"
    :close="close"
    :disabled="!canDownload"
    @input="$emit('input')"
    @click="downloadAttachment"
  >
    <v-avatar>
      <v-progress-circular
        v-if="loading"
        indeterminate
        :size="22"
        :width="2"
      />
      <v-icon v-else>attachment</v-icon>
    </v-avatar>
    <span class="attachment-button__text"><slot /></span>
  </v-chip>
</template>

<script>
  import { mapGetters } from 'vuex'

  // Constants
  import { ROLES } from '@/store/admin'

  export default {
    name: 'AttachmentLink',
    props: {
      href: {
        type: String,
        default: undefined
      },
      loading: {
        type: Boolean,
        default: false
      },
      close: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters('admin', ['hasRole']),
      canDownload () {
        return this.hasRole([
          ROLES.ACCOUNTANT_READ, ROLES.ACCOUNTANT_WRITE,
          ROLES.SUPPORT_READ, ROLES.SUPPORT_WRITE,
          ROLES.MANAGER, ROLES.MANAGER_LEAD
        ]) && this.href != null
      }
    },
    methods: {
      downloadAttachment () {
        if (this.canDownload) {
          window.location.assign(this.href)
        }
      }
    }
  }
</script>

<style lang="scss">
  .attachment-button {
    .v-progress-circular,
    .v-icon {
      color: #d32f2f
    }

    &--clickable {
      .v-chip__content {
        cursor: pointer;
      }
    }

    &--highlight {
      .attachment-button__text {
        color: #d32f2f !important;
      }
    }

    &--deactivated {
      .v-chip__content {
        cursor: not-allowed;
      }
    }
  }
</style>
